import makeStyles from "@material-ui/core/styles/makeStyles";
import { COLORS } from "../../../../constants";

export const useProgramCardStyles = makeStyles(() => ({
  root: {
    width: 732,
    height: 239,
    background: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D682",
    borderRadius: 15,
    "& + &": {
      marginTop: 24,
    },
  },
  header: {
    height: 90,
    borderBottom: "1px solid #DBDBDB;",
    display: "flex",
    padding: "15px 15px",
  },
  content: {
    height: 109,
    borderBottom: "1px solid #DBDBDB;",
    padding: "5px 5px",
    display: "grid",
    gridColumnGap: 2,
    gridTemplateColumns: "1fr 1fr 1fr",
  },
  footer: {
    height: 40,
    padding: "15px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  schoolImage: {
    width: 60,
    height: 60,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  headerInfoContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  headerInfoSubContainer1: {
    marginRight: 14,
    marginLeft: 15,
    maxWidth: 356,
  },
  headerInfoSubContainer2: {
    textAlign: "right",
  },
  headerProgramTypeContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },
  schoolName: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#231F20",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: 1.1,
  },
  majorName: {
    fontSize: 14,
    color: "#231F20",
    marginTop: 5,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  grade: {
    marginLeft: 16,
    fontWeight: "bold",
  },
  bold: {
    fontWeight: "bold",
  },
  degreeName: {
    fontSize: 12,
    color: "#4B4B4B",
    marginTop: 3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  headerProgramType: {
    fontSize: 12,
    color: "#FFFFFF",
    padding: "4px 18px",
    borderRadius: 18,
  },
  backgroundOnline: {
    backgroundColor: "#7D9EF1",
  },
  backgroundOnCampus: {
    backgroundColor: COLORS.message.main,
  },
  tuitionContainer: {
    fontSize: 13,
    color: "#231F20",
    marginTop: 6,
    lineHeight: 1,
    maxHeight: 22,
    overflow: "hidden",
    wordBreak: "break-all",
  },
  tuition: {
    fontSize: 13,
    color: "#858997",
    marginRight: 10,
    textDecoration: "line-through",
  },
  tuitionWithScholarship: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#231F20",
  },
  durationContainer: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#231F20",
    marginTop: 4,
  },
  addressContainer: {
    display: "flex",
    alignItems: "center",
  },
  locationIcon: {
    marginRight: 12,
    marginTop: -4,
  },
  arrowRight: {
    paddingTop: "unset",
  },
  address: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#231F20",
    maxWidth: 530,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  link: {
    display: "flex",
    fontSize: 14,
    fontWeight: "bold",
    color: "#957F2F",
    "&:hover": {
      textDecoration: "none",
      color: "#AA933F",
    },
  },
}));
